import React from 'react';
import OrderLists from '../OrderLists/OrderLists';

/**
 * Sales — the single "money" destination: revenue analytics + order history,
 * B2B-scoped to the courses the current user owns. (Redesign 2026, Phase 6 —
 * discounts moved out; Sales is now a focused, standalone page.)
 */
function SalesHub() {
  return <OrderLists />;
}

export default SalesHub;
